import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import "@fortawesome/free-brands-svg-icons";
import "@fortawesome/free-brands-svg-icons";
import { faCircleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function InvoiceFieldsColombia({
  handleBlurTaxID,
  errors,
  changeStoreField,
  invoiceFields,
  setInvoiceFields,
}) {
  const state = useSelector((state) => state);
  const { t } = useTranslation();

  const { billing, patterns, system_fields } = state.checkoutStore;

  const { doingRequest } = state.ui;

  const [showInvoiceFields, setShowInvoiceFields] = useState(false);

  useEffect(() => {
    if (billing && billing.taxid) {
      setShowInvoiceFields(billing.taxid.length > 5);
    }
  }, [billing]);

  return (
    <div className="col-6 mb-2 form-group">
      <div
        className={`input-placeholder floating-label-wrap mb-3 ${
          errors.taxid ? "error-div-highlight" : ""
        }`}
      >
        <label htmlFor="taxid" className="label-checkout">
          NIT o CC{" "}
          {system_fields.taxid_required ? "*" : t("information.optional")}
        </label>
        <input
          type="text"
          required
          className="floating-label-field form-group floating-label-field--s1"
          id="taxid"
          disabled={doingRequest}
          placeholder={t("information.taxid")}
          value={(billing != null && billing.taxid) || ""}
          onChange={(e) => changeStoreField("taxid", e.target.value)}
          onBlur={handleBlurTaxID}
        />
      </div>
      <div
        className={`field-error ${errors.taxid ? "" : "hidden-error"} mt-n3`}
        style={{
          display: errors.taxid ? "flex" : "",
          alignItems: "center",
        }}
      >
        <FontAwesomeIcon
          icon={faCircleExclamation}
          style={{ paddingRight: "2px" }}
          size="sm"
          fixedWidth
        />
        {t(errors.taxid) +
          (errors.taxid != null
            ? errors.taxid.includes("empty") || errors.taxid.includes("invalid")
              ? ""
              : patterns.taxid_pattern
            : "")}
      </div>

      {showInvoiceFields && (
        <>
          <div className="floating-label-wrap form-group mb-3">
            <label htmlFor={"razonsocial"} className="label-checkout">
              Razon Social
            </label>
            <input
              type="text"
              className="floating-label-field floating-label-field--s1"
              id={"razonsocial"}
              disabled={doingRequest}
              placeholder={"Razon Social"}
              onChange={(e) =>
                setInvoiceFields({
                  ...invoiceFields,
                  "Razon Social": e.target.value,
                })
              }
            />
          </div>

          <div className="floating-label-wrap form-group mb-3">
            <select
              className="floating-label-field floating-label-field--s1"
              id="tipoDeContribuiente"
              disabled={doingRequest}
              defaultValue=""
              onChange={(e) =>
                setInvoiceFields({
                  ...invoiceFields,
                  "Tipo de Contribuiente": e.target.value,
                })
              }
            >
              <option id="tipoDeContribuienteDefaultValue" value="" disabled>
                Tipo de Contribuiente
              </option>
              <option value="Regimen Simplificado">Regimen Simplificado</option>
              <option value="Regimen Comun">Regimen Comun</option>
              <option value="No se aplica">No se aplica</option>
            </select>
          </div>
        </>
      )}
    </div>
  );
}
